module.exports = __webpack_public_path__ + "img/locationDot_blue.c0d04927.svg";